<!-- <app-snowfall></app-snowfall> -->
@if (loading | async) {
  <div class="loading-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>
}
<router-outlet></router-outlet>
<app-toast-container />
